import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿Esto funciona si nunca he hecho marketing antes?',
  answer: 'Sí. Blindaje 21 está diseñado para contratistas que trabajan con las manos, no con computadoras. Todo está explicado paso a paso, sin jerga técnica. Si sabes usar WhatsApp, puedes hacer esto.'
}, {
  question: '¿Necesito gastar dinero en publicidad?',
  answer: 'No necesariamente. Los primeros 7 días se enfocan en reactivar clientes que ya te conocen (costo: $0). La Micro-Licitación de los días 8-14 puede costar entre $20-50 si decides usarla, pero es opcional.'
}, {
  question: '¿Cuánto tiempo necesito dedicarle cada día?',
  answer: 'Entre 30 minutos y 2 horas diarias, dependiendo del día. Está diseñado para que lo hagas temprano en la mañana o después del trabajo. No necesitas dejar de trabajar para implementarlo.'
}, {
  question: '¿Funciona en mi ciudad/estado?',
  answer: 'Sí. El sistema funciona en cualquier mercado de Estados Unidos donde haya dueños de casa que necesiten reparaciones o remodelaciones. De hecho, funciona mejor en ciudades pequeñas donde hay menos competencia.'
}, {
  question: '¿Qué pasa si no veo resultados?',
  answer: 'Si aplicas el plan completo durante 21 días y no consigues al menos un contrato nuevo, te devuelvo tu dinero completo. Sin preguntas. Envíame un email mostrando que seguiste los pasos y listo.'
}, {
  question: '¿Es un curso en video o un PDF?',
  answer: 'Es un PDF de acción directa. Sin videos largos que te hacen perder tiempo. Lees, aplicas, y ves resultados. Incluye plantillas y guiones listos para copiar y pegar.'
}, {
  question: '¿Necesito una página web o redes sociales?',
  answer: 'No. Todo el sistema funciona con WhatsApp, llamadas telefónicas, y visitas en persona. Si tienes un teléfono, tienes todo lo que necesitas.'
}, {
  question: '¿Por qué está tan barato?',
  answer: 'Porque sé lo que es estar quebrado. Podría cobrar $500, pero mi objetivo es ayudar a la mayor cantidad de contratistas hispanos posible. Prefiero que 100 personas paguen $47 y cambien sus negocios, que 5 personas paguen $500.'
}];
function FAQAccordion({
  question,
  answer
}: FAQItem) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200" data-id="element-1">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors px-4 rounded-lg" aria-expanded={isOpen} data-id="element-2">
        <h3 className="font-heading text-xl md:text-2xl text-blueprint-blue pr-4" data-id="element-3">
          {question}
        </h3>
        <ChevronDownIcon className={`w-6 h-6 text-industrial-gray flex-shrink-0 transition-transform duration-300 ${isOpen ? 'transform rotate-180' : ''}`} aria-hidden="true" data-id="element-4" />
      </button>
      {isOpen && <div className="pb-6 px-4" data-id="element-5">
          <p className="text-lg text-industrial-gray leading-relaxed" data-id="element-6">
            {answer}
          </p>
        </div>}
    </div>;
}
export function FAQ() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-7">
      <div className="max-w-4xl mx-auto px-4" data-id="element-8">
        <h2 className="font-heading text-3xl md:text-5xl text-blueprint-blue text-center mb-4" data-id="element-9">
          Preguntas Frecuentes
        </h2>
        <p className="text-xl text-industrial-gray text-center mb-12" data-id="element-10">
          Todo lo que necesitas saber antes de empezar
        </p>

        <div className="bg-gray-50 rounded-lg p-4 md:p-8" data-id="element-11">
          {faqs.map((faq, index) => <FAQAccordion key={index} question={faq.question} answer={faq.answer} data-id="element-12" />)}
        </div>

        {/* Final CTA */}
        <div className="mt-12 text-center" data-id="element-13">
          <p className="text-xl text-industrial-gray mb-6" data-id="element-14">
            ¿Listo para llenar tu calendario?
          </p>
          <button onClick={() => {
          const pricingSection = document.getElementById('pricing');
          pricingSection?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="bg-construction-orange hover:bg-orange-600 text-white font-bold text-xl md:text-2xl px-12 py-5 rounded-lg transition-all duration-300 transform hover:scale-105" aria-label="Obtener Blindaje 21 ahora" data-id="element-15">
            OBTENER BLINDAJE 21 AHORA
          </button>
        </div>
      </div>
    </section>;
}